import { AlertBox, Icon } from '@iwoca/orion';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import FileStatus from './FileStatus';
import messages from './UploadedFilesStatus.messages';
import styles from './UploadedFilesStatus.module.css';
import { getCountryCode } from '../../../lendingAPI/lendingAPISelector';
import { RootState } from '../../../reducers';
import alertStyles from '../AlertBoxes.module.css';
import { UploadedFile } from '../types';

const UploadedFilesStatus = ({
    uploadedFiles,
    uploadAlerts,
    documentType,
    countryCode
}: {
    uploadedFiles: UploadedFile[];
    uploadAlerts: UploadedFile[];
    documentType: string;
    countryCode: string;
}) => {
    const uploadedDocsByDocType = uploadedFiles.filter(
        (file) => file.attributes.document_type === documentType
    );

    const uploadAlertsByDocType = uploadAlerts.filter(
        (file) => file.attributes.document_type === documentType
    );

    return (
        <div
            data-dd-privacy="mask"
            className={classnames('fs-exclude', {
                [styles.uploadedDocsContainer]: uploadedDocsByDocType.length > 0
            })}>
            {uploadedDocsByDocType.map((file: UploadedFile) => (
                <FileStatus key={file.id} file={file} />
            ))}
            {uploadAlertsByDocType.map((file: UploadedFile) => {
                if (!file.attributes) return null;
                if (file.error) {
                    let errorMessage = messages.defaultError;
                    if (countryCode === 'de') {
                        switch (file.error.code) {
                            case 'DocumentUploadError':
                                errorMessage = messages.documentUploadError;
                                break;
                            case 'DuplicateDocumentError':
                                errorMessage = messages.duplicateDocumentError;
                                break;
                            case 'ValidationError':
                                errorMessage = messages.validationError;
                                break;
                            default:
                                errorMessage = messages.defaultError;
                        }
                    }
                    return (
                        <AlertBox
                            data-dd-privacy="mask"
                            key={file.id}
                            className={classnames(
                                alertStyles.alertBox,
                                'fs-exclude'
                            )}
                            variant={'failure'}
                            data-testid="alertbox">
                            <Icon
                                fill={'var(--color-error)'}
                                width={20}
                                height={20}
                                icon="exclamationTriangleOutline"
                                className={alertStyles.cancelAlertBoxIcon}
                            />
                            <FormattedMessage
                                {...errorMessage}
                                values={{
                                    fileName: file.attributes['document_name'],
                                    error: file.error.detail
                                }}
                            />
                        </AlertBox>
                    );
                } else {
                    return (
                        <AlertBox
                            data-dd-privacy="mask"
                            key={file.id}
                            className={classnames(
                                alertStyles.alertBox,
                                'fs-exclude'
                            )}
                            variant={'success'}
                            data-testid="alertbox">
                            <Icon
                                width={20}
                                height={20}
                                fill={'var(--color-success-drk)'}
                                icon="checkCircleFilled"
                                className={alertStyles.successAlertBoxIcon}
                            />
                            <FormattedMessage
                                {...messages.success}
                                values={{
                                    fileName: file.attributes['document_name']
                                }}
                            />
                        </AlertBox>
                    );
                }
            })}
        </div>
    );
};

const mapStateToProps = (state: RootState) => ({
    uploadedFiles: state.tradingHistory.uploadedFiles,
    uploadAlerts: state.tradingHistory.uploadAlerts,
    countryCode: getCountryCode(state)
});

export default connect(mapStateToProps)(UploadedFilesStatus);
